import { Configuration, PopupRequest } from "@azure/msal-browser";

const {
  REACT_APP_AZURE_AD_CLIENT_ID,
  REACT_APP_AZURE_AD_CLOUD_INSTANCE_ID,
  REACT_APP_AZURE_AD_TENANT_ID,
} = process.env;

export const msalConfig: Configuration = {
  auth: {
    clientId: `${REACT_APP_AZURE_AD_CLIENT_ID}`,
    authority: `${REACT_APP_AZURE_AD_CLOUD_INSTANCE_ID}/${REACT_APP_AZURE_AD_TENANT_ID}`,
    redirectUri: `${window.location.origin}/redirect`,
    postLogoutRedirectUri: `${window.location.origin}`,
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

export const loginRequest: PopupRequest = {
  scopes: [`api://${process.env.REACT_APP_AZURE_AD_CLIENT_ID}/access_as_user`],
};
